export default __webpack_public_path__ + "static/media/background.19b91be4.png";